<template>
  <wrapper>
    <template slot="before-menu">
      <back-point icon="chevron-left" to="dashboard">Zurück</back-point>
    </template>

    <template slot="navigation">
      <menu-point to="accounting.report">Berichte</menu-point>
      <menu-point to="accounting.settlement">Abrechnungen</menu-point>
      <menu-point to="accounting.invoice">Rechnungen</menu-point>
    </template>

    <template slot="page">
      <router-view></router-view>
    </template>
  </wrapper>
</template>
    
<script>
import accountClient from "@/api/merchant/account";
import Wrapper from "@/components/Wrapper";
import MenuPoint from "@/components/MenuPoint";
import BackPoint from "@/components/BackPoint";

//import eventsClient from '../../api/events'

export default {
  components: {
    MenuPoint,
    BackPoint,
    Wrapper
  },

  data() {
    return {};
  },

  methods: {}
};
</script>